
const clienDataMapper = (data) => {
    let responseMapper = [];
    for (var i = 0; i < data.length; i++) {
        responseMapper[i] = {
            monthnumber: data[i].monthnumber ?? '',
            name: data[i].monthdata ?? '',
            Clientes: data[i].clientes ?? ''
        }
        responseMapper.push();
    }

    return responseMapper;
}


const clienDataByMonthMapper = (dataResponse) => {
    try {
        if (!dataResponse || !dataResponse.data || !Array.isArray(dataResponse.data)) {
            throw new Error("Datos inválidos");
        }

        const responseTableMapper = dataResponse.data.map(item => ({
            id: item.id ?? '',
            Cliente: item.names + ' ' + item.middle_name ?? '',
            Identificacion: item.identification ?? '',
            Email: item.email ?? '',
            Orden: item.code ?? '',
            Producto: item.nombre ?? '',
            Fecha: item.creation_date ?? '',
        }));

        return {
            error: false,
            variant: "success",
            responseTableMapper,
            page: dataResponse.page,
            per_page: dataResponse.per_page,
            total_records: dataResponse.total_records,
            total_pages: dataResponse.total_pages,
            url: dataResponse.url
        };
    } catch (error) {
        return {
            error: true,
            variant: "error",
            message: error.message || "Error al procesar los datos"
        };
    }
}

const earnDataMapper = (data) => {
    let responseMapper = [];
    for (var i = 0; i < data.length; i++) {
        responseMapper[i] = {
            monthnumber: data[i].monthnumber ?? '',
            name: data[i].monthdata ?? '',
            Utilidad: data[i].total ?? ''
        }
        responseMapper.push();
    }

    return responseMapper;
}

const earnBarDataMapper = (data) => {
    let responseMapper = [];
    for (var i = 0; i < data.length; i++) {
        responseMapper[i] = {
            name: data[i].mes ?? '',
            Atentdidos: data[i].atendidos ?? '',
            Canceladas: data[i].canceladas_cliente ?? '',
            Perdidos: data[i].finalizados_fecha ?? ''
        }
        responseMapper.push();
    }

    return responseMapper;
}

const earnDonutDataMapper = (data) => {
    let responseMapper = [];
    for (var i = 0; i < data.length; i++) {
        responseMapper[i] = {
            id: data[i].id ?? '',
            name: data[i].label ?? '',
            value: parseInt(data[i].value) ?? 0,
        }
        responseMapper.push();
    }

    return responseMapper;
}

const earnDataByMonthMapper = (dataResponse) => {
    try {
        if (!dataResponse || !dataResponse.data || !Array.isArray(dataResponse.data)) {
            throw new Error("Datos inválidos");
        }

        const responseTableMapper = dataResponse.data.map(item => ({
            Fecha: item.creation_date ?? '',
            Sku: item.sku ?? '',
            Nombre: item.nombre ?? '',
            Cantidad: item.cantidad ?? '',
            Precio: item.precio ?? '',
            Iva: item.iva ?? '',
            SubTotal: item.subtotal ?? '',
            Descuento: item.tiene_descuento ?? '',
            "Tarifa Descuento": item.tarifa_descuento ?? '',
            "Precio Descuento": item.precio_descuento ?? '',
            "Iva Descuento": item.iva_descuento ?? '',
            "Subtotal Descuento": item.subtotal_descuento ?? '',
            "Total Descuento": item.total_descuento ?? '',
        }));

        return {
            error: false,
            variant: "success",
            responseTableMapper,
            page: dataResponse.page,
            per_page: dataResponse.per_page,
            total_records: dataResponse.total_records,
            total_pages: dataResponse.total_pages,
            url: dataResponse.url
        };
    } catch (error) {
        return {
            error: true,
            variant: "error",
            message: error.message || "Error al procesar los datos"
        };
    }
}

const statusDataByServiceMapper = (data) => {
    let responseMapper = [];
    for (var i = 0; i < data.length; i++) {
        responseMapper[i] = {
            id: data[i].id ?? '',
            Descripción: data[i].description ?? '',
            Fecha: data[i].creation_date ?? '',
            Código: data[i].code ?? '',
            "Hora inicio": data[i].start_hour ?? '',
            "Hora fin": data[i].end_hour ?? '',
        }
        responseMapper.push();
    }

    return responseMapper;
}

// eslint-disable-next-line import/no-anonymous-default-export
export default {
    clienDataMapper,
    clienDataByMonthMapper,
    earnDataMapper,
    earnBarDataMapper,
    earnDonutDataMapper,
    statusDataByServiceMapper,
    earnDataByMonthMapper
}